import { add } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'

import { CodingPeriodInfo, ICreateMileageLossRequest, Log, LogSource, LogStatus } from '@/types/logs'

const DEFAULT_CODING_PERIOD: CodingPeriodInfo = {
    codingPeriod: 'LogCreation',
    permissions: ['View', 'Create', 'Update', 'Delete'],
    deadline: formatInTimeZone(add(new Date(), { days: 7 }), 'UTC', "yyyy-MM-dd'T'HH:mm:ss"),
}

export const formatMileageLossRequestBody = (requestBody: ICreateMileageLossRequest): Log => {
    const { eventLogId, ...rest } = requestBody

    const log: Partial<Log> = {
        ...rest,
        descriptionInfo: {
            description: '',
            extraInfo: '',
            strategy: '',
        },
        codingPeriodInfo: DEFAULT_CODING_PERIOD,
        source: LogSource.Manual,
        timestamp: requestBody.timeStamp || formatInTimeZone(new Date(), 'UTC', "yyyy-MM-dd'T'HH:mm:ss'Z'"),
        status: LogStatus.Incomplete,
        eventLog: requestBody.eventLogId
            ? ({
                  id: requestBody.eventLogId,
              } as Log)
            : null,
    }

    return log as Log
}
